export const ABYSSINIAN_RUS = 'Абиссинская';
export const ABYSSINIAN_ENG = 'abyssinian';
export const BENGAL_RUS = 'Бенгальская';
export const BENGAL_ENG = 'bengal';
export const BRITISH_RUS = 'Британская';
export const BRITISH_ENG = 'british';
export const CANADIAN_SPHINX_RUS = 'Канадский сфинкс';
export const CANADIAN_SPHINX_ENG = 'canadianSphinx';
export const MAINE_COON_RUS = 'Мейн-кун';
export const MAINE_COON_ENG = 'maineCoon';
export const PERSIAN_RUS = 'Персидская';
export const PERSIAN_ENG = 'persian';
export const SIAMESE_RUS = 'Сиамская';
export const SIAMESE_ENG = 'siamese';
export const NEVA_MASQUERADE_RUS = 'Сибирская (невская маскарадная)';
export const NEVA_MASQUERADE_ENG = 'nevaMasquerade';
export const SCOTTISH_RUS = 'Шотландская кошка (вислоухая и прямоухая)';
export const SCOTTISH_ENG = 'scottish';
export const CAT_BREEDS = {
    [ABYSSINIAN_RUS]: ABYSSINIAN_ENG,
    [BENGAL_RUS]: BENGAL_ENG,
    [BRITISH_RUS]: BRITISH_ENG,
    [CANADIAN_SPHINX_RUS]: CANADIAN_SPHINX_ENG,
    [MAINE_COON_RUS]: MAINE_COON_ENG,
    [PERSIAN_RUS]: PERSIAN_ENG,
    [SIAMESE_RUS]: SIAMESE_ENG,
    [NEVA_MASQUERADE_RUS]: NEVA_MASQUERADE_ENG,
    [SCOTTISH_RUS]: SCOTTISH_ENG,
};
export const YORKSHIRE_TERRIER_RUS = 'Йоркширский терьер';
export const YORKSHIRE_TERRIER_ENG = 'yorkshireTerrier';
export const CORGI_RUS1 = 'Вельш-корги-кардиган';
export const CORGI_ENG = 'corgi';
export const CORGI_RUS2 = 'Вельш-корги-пемброк';
export const LABRADOR_RETRIEVER_RUS = 'Лабрадор-ретривер';
export const LABRADOR_RETRIEVER_ENG = 'labradorRetriever';
export const PUG_RUS = 'Мопс';
export const PUG_ENG = 'pug';
export const GERMAN_SHEPHERD_RUS = 'Немецкая овчарка';
export const GERMAN_SHEPHERD_ENG = 'germanShepherd';
export const GERMAN_SPITZ_RUS = 'Немецкий шпиц (померанский)';
export const GERMAN_SPITZ_ENG = 'germanSpitz';
export const SIBERIAN_HUSKY_RUS = 'Сибирский хаски';
export const SIBERIAN_HUSKY_ENG = 'siberianHusky';
export const DACHSHUND_RUS = 'Такса';
export const DACHSHUND_ENG = 'dachshund';
export const FRENCH_BULLDOG_RUS = 'Французский бульдог';
export const FRENCH_BULLDOG_ENG = 'frenchBulldog';
export const CHIHUAHUA_RUS = 'Чихуахуа';
export const CHIHUAHUA_ENG = 'chihuahua';
export const RUSSKIJ_TOJ_RUS = 'Русский той';
export const RUSSKIJ_TOJ_ENG = 'russkij-toj';
export const DOG_BREEDS = {
    [YORKSHIRE_TERRIER_RUS]: YORKSHIRE_TERRIER_ENG,
    [CORGI_RUS1]: CORGI_ENG,
    [CORGI_RUS2]: CORGI_ENG,
    [LABRADOR_RETRIEVER_RUS]: LABRADOR_RETRIEVER_ENG,
    [PUG_RUS]: PUG_ENG,
    [GERMAN_SHEPHERD_RUS]: GERMAN_SHEPHERD_ENG,
    [GERMAN_SPITZ_RUS]: GERMAN_SPITZ_ENG,
    [SIBERIAN_HUSKY_RUS]: SIBERIAN_HUSKY_ENG,
    [DACHSHUND_RUS]: DACHSHUND_ENG,
    [FRENCH_BULLDOG_RUS]: FRENCH_BULLDOG_ENG,
    [CHIHUAHUA_RUS]: CHIHUAHUA_ENG,
    [RUSSKIJ_TOJ_RUS]: RUSSKIJ_TOJ_ENG,
};
